import { render, staticRenderFns } from "./versionControl.vue?vue&type=template&id=3d36160b&scoped=true"
import script from "./versionControl.vue?vue&type=script&lang=js"
export * from "./versionControl.vue?vue&type=script&lang=js"
import style0 from "./versionControl.vue?vue&type=style&index=0&id=3d36160b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d36160b",
  null
  
)

export default component.exports